import { isObject } from 'src/utils/stateForm/helpers/cloneDeep/helpers/isObject';

export const isPlainObject = (tempObject: object) => {
  const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;

  // eslint-disable-next-line no-prototype-builtins
  return isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
